import * as Sentry from '@sentry/capacitor';

export type BootPhase =
  | 'pre_check'
  | 'checking'
  | 'downloading'
  | 'applying'
  | 'rendered';

let current: BootPhase = 'pre_check';

export const setBootPhase = (phase: BootPhase): void => {
  current = phase;
  try {
    Sentry.setTag('boot_phase', phase);
  } catch {
    // Boot phase is diagnostic only. If Sentry is not initialised yet (or init failed), keep
    // tracking the phase in memory and never let telemetry break boot.
  }
};

export const getBootPhase = (): BootPhase => current;
